import { ConfigIconProvider } from '@fuxi/eevee-ui';
import { ICON_LINK } from 'common/constants/common';

export const EeveeIconContext = ({ children, ...props }: { [key: string]: any }) => {
  return (
    <ConfigIconProvider cdnLink={ICON_LINK} defaultSize={20} {...props}>
      {children}
    </ConfigIconProvider>
  );
};
